import {layer, source, data} from "azure-maps-control";

import type {Shape} from "azure-maps-control";

export class AzureDragPointHandler {

    private readonly baseMapModule;
    private _eventChannel = es.util.createEventChannel({onDragStart:1, onDragEnd: 1, onDestroy: 1}, "es.map.handler.DragPointHandler");

    private datasource: any;
    private symbolLayer: any;

    private selectedShape: Shape|undefined;

    private _destroyed: boolean = false;

    constructor(baseMapModule: any, geom: any, label: string, style: any) {
        this.baseMapModule = baseMapModule;

        // init symbol if required
        this.baseMapModule.imageSpriteManager.addFromStyle(style).then(() => {
            this.init(baseMapModule, geom, label, style);
        });
    }

    private init(baseMapModule: any, geom: any, label: string, style: any){

        if (this._destroyed) {
            return;
        }

        //Create a pin at the center of the map and pass in some properties that are unique to the pin.
        const pin = new data.Feature(new data.Point(geom.slice(1)), {
            title: label
        });

        //Create a data source and add it to the map.
        this.datasource = new source.DataSource();
        baseMapModule.map.sources.add(this.datasource);
        this.datasource.add(pin);

        //Add a layer for rendering point data as symbols.
        const options: any = {
            iconOptions: {
                ignorePlacement: true, //To skip label collision detection for better performance.
                allowOverlap: true,    //To ensure smooth rendering when dragging, allow symbol to overlap all other symbols on the map.
                offset: [0, 0],
                anchor: 'center'
            }
        };

        if (style?.$type === 'SymbolStyle') {
            options.iconOptions.image = `es_${style.symbolTypeId}_${style.size}_${style.color}`;
        }

        this.symbolLayer = new layer.SymbolLayer(this.datasource, "dragpoint_handler", options);
        baseMapModule.map.layers.add(this.symbolLayer);

        baseMapModule.map.events.add("mousedown", this.symbolLayer, (e: any) => {
            //console.log("mousedown")
            if (e.shapes && e.shapes.length > 0) {
                //Capture the selected shape.
                this.selectedShape = e.shapes[0];

                //Lock the maps ability to pan so that we can drag the symbol.
                baseMapModule.map.setUserInteraction({
                    dragPanInteraction: false
                });
                this.eventChannel.fireEvent("onDragStart");
            }
        });
        baseMapModule.map.events.add("mousemove", (e: any) => {
            if (this.selectedShape) {
                this.selectedShape.setCoordinates(e.position);
            }
        });
        baseMapModule.map.events.add("mouseup", () => {
            this.finishDragging();
        });
    }

    private finishDragging() {
        if(!this.selectedShape) {
            return;
        }

        const coords = this.selectedShape.getCoordinates();
        let geom;
        if (this.selectedShape.getType() === "Point") {
            geom = ["PT", ...coords];
        } else if (this.selectedShape.getType() === "Polygon"){

        }
        this.eventChannel.fireEvent("onDragEnd", $.extend(true, [], geom));

        //Stop tracking the selected shape.
        this.selectedShape = undefined;
        //Make map panable again.
        this.baseMapModule.map.setUserInteraction({dragPanInteraction: true});
    }

    get eventChannel(): any {
        return this._eventChannel;
    }

    public destroy() {
        this._destroyed = true;
        this.selectedShape = undefined;
        if (this.datasource && this.symbolLayer) {
            this.baseMapModule.map.layers.remove(this.symbolLayer.getId());
            this.baseMapModule.map.sources.remove(this.datasource.getId());
            this.datasource = undefined;
            this.symbolLayer= undefined;
        }
        this.eventChannel.fireEvent("onDestroy");
    }
}
